import React from 'react';
import PropTypes from 'prop-types';
import {ORDER, ORDER_CHANNELS, ORDER_SOURCE} from 'helpers/constants/orders_v2';
import UberEats from 'assets/uber-eats.svg';
import Doordash from 'assets/icon-doordash.svg';
import Grubhub from 'assets/icon-grubhub.svg';
import Slice from 'assets/icon-slice.png';
import EZCater from 'assets/icon-ez-cater.jpeg';
import Otter from 'assets/icon-otter.png';
import IconSauceDelivery from 'assets/icon-sauce-delivery.svg';
import SpotOn from 'assets/icon-spoton.png';

const OrderSourceIcon = ({order}) => {
  const source = order[ORDER.SOURCE];
  const channel = order[ORDER.CHANNEL];

  if (channel === ORDER_CHANNELS.SPOTON) {
    if (source === ORDER_SOURCE.UBER) {
      return <img src={UberEats} alt='logo' />;
    }
    if (source === ORDER_SOURCE.DOORDASH) {
      return <img src={Doordash} alt='logo' />;
    }
    if (source === ORDER_SOURCE.GRUBHUB) {
      return <img src={Grubhub} alt='logo' />;
    }
    return <img className='spoton-logo' src={SpotOn} alt='logo' />;
  }

  if (source === ORDER_SOURCE.SAUCE || source === ORDER_SOURCE.SAUCE_DSP) {
    return <img src={IconSauceDelivery} alt='logo' />;
  }
  if (source === ORDER_SOURCE.UBER) {
    return <img src={UberEats} alt='logo' />;
  }
  if (source === ORDER_SOURCE.DOORDASH) {
    return <img src={Doordash} alt='logo' />;
  }
  if (source === ORDER_SOURCE.GRUBHUB) {
    return <img src={Grubhub} alt='logo' />;
  }
  if (source === ORDER_SOURCE.SLICE) {
    return <img className='slice-logo' src={Slice} alt='logo' />;
  }
  if (source === ORDER_SOURCE.EZCATER) {
    return <img className='ez-cater-logo' src={EZCater} alt='logo' />;
  }
  if (source === ORDER_SOURCE.OTTER) {
    return <img className='ez-cater-logo' src={Otter} alt='logo' />;
  }

  return <img src={IconSauceDelivery} alt='logo' />;
};

OrderSourceIcon.propTypes = {
  order: PropTypes.object.isRequired
};

export default OrderSourceIcon;
